import { LayoutWithNavigationBar } from "../../../layouts/layout-with-navigation-bar";
import { MainView } from "../../../views/inbound/in-progress";

export default function Inbound_In_ProgressPage(props) {
    return (
        <>
            <LayoutWithNavigationBar>
                <MainView />
            </LayoutWithNavigationBar>
        </>
    );
}